<script lang="ts" setup>
interface Props {
  columns?: '1' | '2' | '3' | '4' | '2/3';
  gap?: 'sm' | 'md' | 'lg' | 'xl';
}

const props = withDefaults(defineProps<Props>(), {
  columns: '3',
  gap: 'md',
});

const variantClasses = computed(() => {
  return twMerge(
    cva('grid grid-cols-1', {
      variants: {
        columns: {
          '1': '',
          '2': 'md:grid-cols-1 xl:grid-cols-2',
          '3': 'md:grid-cols-2 xl:grid-cols-3',
          '4': 'md:grid-cols-2 xl:grid-cols-4',
          '2/3': 'md:grid-cols-2 xl:grid-cols-6 first:xl:col-span-2 nth-2:xl:col-span-2',
        },
        gap: {
          sm: 'gap-2',
          md: 'gap-4',
          lg: 'gap-6',
          xl: 'gap-8',
        },
      },
    })({
      columns: props.columns,
      gap: props.gap,
    }),
  );
});

const childVariantClasses = computed(() => {
  return twMerge(
    cva('', {
      variants: {
        columns: {
          '1': '',
          '2': '',
          '3': '',
          '4': '',
          '2/3': 'xl:col-span-2 first:xl:col-span-3 nth-2:xl:col-span-3',
        },
      },
    })({
      columns: props.columns,
    }),
  );
});

const slots = useSlots();

const listChildren = computed(() => {
  return slots.default?.()?.[0]?.children ?? [];
});
</script>

<template>
  <ul :class="variantClasses">
    <li
      v-for="(child, index) in listChildren"
      :key="`card-list-${index}`"
      :class="childVariantClasses"
    >
      <component :is="child" />
    </li>
  </ul>
</template>
